import ATMCountComponent from './atm_count.component';
import ATMCountPrintModule from './print';

let ATMCountModule = angular.module('atmCount', [ATMCountPrintModule])

    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $urlRouterProvider.otherwise('/atm-count');

        $stateProvider
            .state('atmCount', {
                url: '/atm-count',
                component: 'atmCount',
                data: {
                    requireLogin: true,
                    requireACL: 'atm_count.all'
                },
                parent: 'app'
            });
    })

    .component('atmCount', ATMCountComponent)

    .directive('roundTo2Decimals', function () {
        return {
            require: ['ngModel', '^atmCount'],
            link: function (scope, element, attrs, ctrls) {
                var ngModel = ctrls[0];
                var atmCountCtrl = ctrls[1];
                if (!atmCountCtrl || typeof atmCountCtrl.roundTo2DecimalsForDisplay !== 'function') return;
                ngModel.$formatters.push(function (value) {
                    if (value == null || value === '') return value;
                    return atmCountCtrl.roundTo2DecimalsForDisplay(value);
                });
            }
        };
    })
    .directive('denominationMultiple', function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                denomFaceValue: '<denominationMultiple',
                coinPackaging: '<',
                unitValue: '<'
            },
            link: function (scope, element, attrs, ngModel) {
                function isValidAmount(amount, faceValue) {
                    if (!amount) return true;

                    var face = Number(faceValue) || 0;
                    var value = Number(amount);

                    if (!isFinite(value) || face <= 0) return true;
                    if (value <= 0) return true;

                    var faceStr = face.toString();
                    var valueStr = value.toString();

                    var faceDecimals = 0;
                    var faceDotIndex = faceStr.indexOf('.');
                    if (faceDotIndex >= 0) {
                        faceDecimals = faceStr.length - faceDotIndex - 1;
                    }

                    var valueDecimals = 0;
                    var valueDotIndex = valueStr.indexOf('.');
                    if (valueDotIndex >= 0) {
                        valueDecimals = valueStr.length - valueDotIndex - 1;
                    }

                    // Use the maximum decimal places from either the face value or the user input
                    var decimals = Math.max(faceDecimals, valueDecimals);
                    var factor = Math.pow(10, decimals);

                    var scaledFace = Math.round(face * factor);
                    if (scaledFace <= 0) return true;

                    var scaledValue = Math.round(value * factor);

                    if (scaledValue < scaledFace) return false;
                    return scaledValue % scaledFace === 0;
                }

                ngModel.$validators.denominationMultiple = function (modelValue) {
                    // Default to standard face value logic
                    var targetValidationValue = scope.denomFaceValue;

                    // Override for ROLLED and INDIVIDUAL to check against unitValue instead
                    if (scope.unitValue && ['ROLLED', 'INDIVIDUAL'].includes(scope.coinPackaging)) {
                        targetValidationValue = scope.unitValue;
                    }

                    return isValidAmount(modelValue, targetValidationValue);
                };

                scope.$watchGroup(['denomFaceValue', 'coinPackaging', 'unitValue'], function () {
                    ngModel.$validate();
                });
            }
        };
    })

    .name;

export default ATMCountModule;


// WEBPACK FOOTER //
// ./client/app/components/atm_count/index.js